export const CancellationPath = {
  CONFIRM: 'confirm',
}
